module.exports = __webpack_public_path__ + "fonts/NotoSansTC-Regular.d6b43f66.otf";